import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _setTimeout from "@babel/runtime-corejs3/core-js-stable/set-timeout";
import * as _ from "../../../../util/lodash";
import React, { useState, useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { ChromePicker } from 'react-color';
import validators from "../../../../validators";
/**
 * color props that can be set using the custom color pickers
 */

export var colorProps = {
  COLOR: 'color',
  BACKGROUND: 'background'
};
colorProps.ALL = _valuesInstanceProperty(_).call(_, colorProps);
/**
 * color sources we are looking to handle from react-color
 */

var colorSources = {
  HSL: 'hsl',
  HSV: 'hsv'
};
var defaultButtonColor = '#CCC';
/**
 * Toolbar color picker component.
 */

var CustomColorPicker = function CustomColorPicker(_ref) {
  var colorProp = _ref.colorProp,
      selectionColorStyles = _ref.selectionColorStyles,
      onChange = _ref.onChange,
      onColorPickerVisibilityChange = _ref.onColorPickerVisibilityChange;
  var pickerRef = useRef();

  var _useState = useState(false),
      isPickerVisible = _useState[0],
      setIsPickerVisible = _useState[1]; //picker visibility


  var _useState2 = useState(''),
      currentColor = _useState2[0],
      setCurrentColor = _useState2[1]; //picker current color


  var currentColorRef = useRef(currentColor); //current color reference
  //keeps a reference to the 'currentColor', otherwise we can't access the color in the document click handlers(due to their closure pointing to the values at their creation time)

  useEffect(function () {
    currentColorRef.current = currentColor;
  }, [currentColor]);
  useEffect(function () {
    setCurrentColor(_.isArray(selectionColorStyles[colorProp]) ? '' : selectionColorStyles[colorProp] || '');
  }, [selectionColorStyles]);
  var handleDocumentClick = useCallback(function (event) {
    event.preventDefault();
    event.stopPropagation(); //if the click has happened outside the picker, we need to close the picker

    if (pickerRef.current && !pickerRef.current.contains(event.target)) {
      onChange({
        colorProp: colorProp,
        value: currentColorRef.current
      });
      setIsPickerVisible(false);
    }
  }, []); //we don't have a clear way of hooking into the react-color pickers input box, so we need to listen for keyboard events bubbling up from it

  var handleKeyboard = useCallback(function (event) {
    // escape key
    if (event.key === 'Escape') {
      setIsPickerVisible(false);
    } //enter key


    if (event.key === 'Enter') {
      onChange({
        colorProp: colorProp,
        value: currentColorRef.current
      });
      setIsPickerVisible(false);
      event.stopPropagation();
      event.preventDefault();
    }
  }, []);
  useEffect(function () {
    return function () {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, []);
  useEffect(function () {
    if (isPickerVisible) {
      //this setTimeout is needed. Otherwise, the click event from the <button bubbles up and is being called by document.addEventListener('click', handleDocumentClick); right away
      //can't stop the bubble on the buttons onChange handler, cause we do need to let it bubble up, so it can be picked up by the "other" picker(we have color and bg at the same time)
      //so, all this code needs to do: stop the document click to execute on the first click of the button
      _setTimeout(function () {
        document.addEventListener('click', handleDocumentClick);
      }, 1);
    } else {
      document.removeEventListener('click', handleDocumentClick);
    }

    onColorPickerVisibilityChange(colorProp, isPickerVisible);
  }, [isPickerVisible]); //handler for color change

  var handleChangeComplete = function handleChangeComplete(value) {
    setCurrentColor(value.hex); //sets the color as received from Quill
    //only call onChange if the color was changed using the mouse over the hsl/hsv controls. No alpha at this point

    if ((value.source === colorSources.HSL || value.source === colorSources.HSV) && validators.isColor()(value.hex) === true) {
      onChange({
        colorProp: colorProp,
        value: value.hex
      });
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "custom-color-button"
  }, /*#__PURE__*/React.createElement("button", {
    className: "ql-" + colorProp,
    style: {
      stroke: colorProp === colorProps.BACKGROUND ? currentColor : currentColor || defaultButtonColor
    },
    onClick: function onClick() {
      return setIsPickerVisible(!isPickerVisible);
    }
  }), /*#__PURE__*/React.createElement("div", {
    ref: pickerRef,
    onKeyDown: handleKeyboard
  }, isPickerVisible ? /*#__PURE__*/React.createElement(ChromePicker, {
    color: currentColor,
    disableAlpha: true,
    onChangeComplete: handleChangeComplete
  }) : null));
};

CustomColorPicker.propTypes = {
  colorProp: PropTypes.oneOf(colorProps.ALL).isRequired,
  selectionColorStyles: PropTypes.shape({
    color: PropTypes.string,
    background: PropTypes.string
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onColorPickerVisibilityChange: PropTypes.func.isRequired
};
export default CustomColorPicker;
//# sourceMappingURL=custom-color-picker.js.map